import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';

const TagInput = ({ tags, setTags }) => {
  const [inputValue, setInputValue] = useState('');
  const safeTags = Array.isArray(tags) ? tags : [];

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const val = inputValue.trim();
      if (val && !safeTags.includes(val)) {
        setTags([...safeTags, val]);
        setInputValue('');
      }
    } else if (e.key === 'Backspace' && !inputValue && safeTags.length > 0) {
      removeTag(safeTags.length - 1);
    }
  };

  const removeTag = (index) => {
    setTags(safeTags.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2 mb-2 p-2 border rounded-lg bg-slate-50 min-h-[42px] items-center">
        {safeTags.map((tag, index) => (
          <Badge 
            key={index} 
            variant="secondary" 
            className="gap-1 px-2 py-1 bg-primary/10 text-primary border-primary/20"
          >
            {tag}
            <button
              type="button"
              onClick={() => removeTag(index)}
              className="hover:text-red-500 transition-colors"
            >
              <X size={14} />
            </button>
          </Badge>
        ))}
        {safeTags.length === 0 && <span className="text-slate-400 text-sm px-2">No tags added yet</span>}
      </div>
      <Input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type tag and press Enter..."
        className="focus-visible:ring-primary"
      />
    </div>
  );
};

export default TagInput;
